import { DeliveryStatus } from 'types/kinerja-ps'

import type { TPredicateKey } from 'types/kinerja-ps'

export const penilaianStateLabel = (
  status?: DeliveryStatus,
  fallback: string = 'Semua'
) => {
  if (!status) return fallback

  let label = fallback

  switch (status) {
    case DeliveryStatus.ALL:
      label = fallback
      break

    case DeliveryStatus.BELUM_DIKIRIM:
      label = 'Belum dikirim'
      break

    case DeliveryStatus.SUDAH_DIKIRIM:
      label = 'Sudah dikirim'
      break

    case DeliveryStatus.BELUM_DINILAI:
      label = 'Belum selesai dinilai'
      break
  }

  return label
}

export const predicateLabel = (
  predicate: TPredicateKey,
  fallback: string = ''
) => {
  let label = fallback

  switch (predicate) {
    case 'nilaiSangatBaik':
      label = 'Sangat Baik'
      break

    case 'nilaiBaik':
      label = 'Baik'
      break

    case 'nilaiButuhPerbaikan':
      label = 'Butuh Perbaikan'
      break

    case 'nilaiKurang':
      label = 'Kurang'
      break

    case 'nilaiSangatKurang':
      label = 'Sangat Kurang'
      break

    default:
      label = fallback
      break
  }

  return label
}
